import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import CategoryToolTile from './CategoryToolTile';

const SearchRow = props => {
  const {
    fptiClick,
    toolTileProps: {
      flatPSData: { tools, categories },
      RPSFavorites = {}
    },
    appSearch: { results = [], query = '' },
    clearSearch,
    dispatch
  } = props;

  const handleClickTool = ({ fptiLink, prod, categoryKey }) => {
    return () => {
      const categoryFPTI = categories[categoryKey]?.categoryFPTI || categoryKey;
      //Don't clear the search if the user is just favoriting the card
      if (!fptiLink.includes('favorite')) {
        dispatch(clearSearch());
      }
      return fptiClick({
        fptiLink,
        prod,
        pageLink: `${categoryFPTI}:search`,
        srch: query
      });
    };
  };

  //suppress the impression event from firing when the card renders from search results
  const noop = () => {};

  const getSearchResults = useMemo(() => {
    return results.map((toolName, i) => {
      const categoryKey = tools[toolName]?.categoryKey;
      return (
        <CategoryToolTile
          key={`category-row-tool-${i}`}
          handleClickTool={handleClickTool}
          {...props}
          fptiImpression={noop}
          tool={tools[toolName]}
          path={`/appcenter/${categories[categoryKey]?.location}`}
          isRecommendCategory={false}
        />
      );
    });
  }, [results, RPSFavorites]);

  return (
    <div id="search-row">
      <div className="category-row">{getSearchResults}</div>
    </div>
  );
};

SearchRow.propTypes = {
  categories: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  clearSearch: PropTypes.func.isRequired,
  fptiClick: PropTypes.func.isRequired,
  toolTileProps: PropTypes.shape({
    flatPSData: PropTypes.shape({
      tools: PropTypes.object.isRequired,
      categories: PropTypes.object.isRequired
    }),
    RPSFavorites: PropTypes.object
  }),
  appSearch: PropTypes.shape({
    query: PropTypes.string,
    results: PropTypes.arrayOf(PropTypes.string)
  })
};

export default SearchRow;
